<template>
  <div>
    <div class="register-channel-item">
      <span class="register-channel-label">距离页面左侧</span>
      <el-input-number controls-position="right" v-model="localValue.left" class="register-channel-select"
        size="small"></el-input-number>
    </div>
    <div class="register-channel-item">
      <span class="register-channel-label">距离页面顶部</span>
      <el-input-number controls-position="right" v-model="localValue.top" class="register-channel-select"
        size="small"></el-input-number>
    </div>
    <div class="register-channel-item">
      <span class="register-channel-label">文字颜色</span>
      <el-color-picker v-model="localValue.color" size='small' />
    </div>
  </div>

</template>

<script>
export default {
  name: "api_select",
  props: {
    value: {
      type: Object
    },
    uuid: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      localValue: {},
      options: []
    }
  },
  methods: {
  },
  watch: {
    uuid: {
      handler(val) {
        this.localValue = this.value
      },
      immediate: true,
    },
    localValue: {
      handler(val) {
        this.$emit('input', val)
      }
    },
  }
}
</script>

<style lang="scss" scoped></style>